import { useRef, useState } from 'react';
import { C } from '../theme/palette';
import { captureLePointeur, pointsDuMouvement, useBloqueLeDefilement } from './bloqueDefilement';

export function SignPad({ value, onChange, color = C.navy }) {
  // Le tracé en cours vit dans une référence : l'état de React n'est relu
  // qu'au rendu suivant, et les premiers points d'un trait se perdaient.
  const enCours = useRef(false);
  const [strokes, setStrokes] = useState(value ? [value] : []);
  const [cur, setCur] = useState('');
  const curRef = useRef('');
  const ref = useRef(null);
  useBloqueLeDefilement(ref);
  const pos = (e) => {
    const el = ref.current;
    const r =
      el && el.getBoundingClientRect
        ? el.getBoundingClientRect()
        : { left: 0, top: 0, width: 320, height: 130 };
    const w = r.width || 320;
    const h = r.height || 130;
    return (
      (((e.clientX - r.left) / w) * 320).toFixed(1) +
      ' ' +
      (((e.clientY - r.top) / h) * 130).toFixed(1)
    );
  };
  const trace = (d) => {
    curRef.current = d;
    setCur(d);
  };
  const down = (e) => {
    if (e.preventDefault) e.preventDefault();
    captureLePointeur(e);
    enCours.current = true;
    trace('M' + pos(e));
  };
  const move = (e) => {
    if (!enCours.current) return;
    if (e.preventDefault) e.preventDefault();
    trace(
      curRef.current +
        pointsDuMouvement(e)
          .map((p) => ' L' + pos(p))
          .join(''),
    );
  };
  const up = () => {
    if (!enCours.current) return;
    enCours.current = false;
    const d = curRef.current;
    const all = d ? [...strokes, d] : strokes;
    setStrokes(all);
    trace('');
    onChange && onChange(all.join(' '));
  };
  const clear = () => {
    setStrokes([]);
    trace('');
    onChange && onChange('');
  };
  const has = strokes.length > 0 || cur;
  return (
    <div>
      <svg
        ref={ref}
        onPointerDown={down}
        onPointerMove={move}
        onPointerUp={up}
        onPointerCancel={up}
        viewBox="0 0 320 130"
        style={{
          width: '100%',
          height: 130,
          border: '2px dashed ' + C.border,
          borderRadius: 10,
          background: C.white,
          touchAction: 'none',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          WebkitTouchCallout: 'none',
          cursor: 'crosshair',
        }}
      >
        {!has && (
          <text x="50%" y="50%" textAnchor="middle" fill={C.muted} fontSize="11">
            ✍️ Signe ici
          </text>
        )}
        {[...strokes, cur].filter(Boolean).map((d, i) => (
          <path
            key={i}
            d={d}
            fill="none"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ))}
      </svg>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}>
        <button
          onClick={clear}
          style={{
            background: 'none',
            border: 'none',
            color: C.muted,
            fontSize: 9,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Effacer
        </button>
      </div>
    </div>
  );
}
